import MenuCard from "../../components/cards/MenuCard";
import HeaderSignOut from "../../components/headers/HeaderSignOut";
import { API_URL } from "../../consts/ApiUrl";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import LockResetRoundedIcon from "@mui/icons-material/LockResetRounded";
import ManageAccountsRoundedIcon from "@mui/icons-material/ManageAccountsRounded";
import SimCardDownloadRoundedIcon from "@mui/icons-material/SimCardDownloadRounded";
import SwitchAccessShortcutAddRoundedIcon from "@mui/icons-material/SwitchAccessShortcutAddRounded";
import { Box, Container, Typography, CircularProgress } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MenuPage: FC = () => {
  const [plan, setPlan] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect((): void => {
    const fetchPlan: () => Promise<void> = async (): Promise<void> => {
      try {
        const loginId: string = sessionStorage.getItem("loginId") || "";
        const idToken: string = sessionStorage.getItem("idToken") || "";
        const headers: Record<string, string> = {
          "Content-Type": "application/json",
          Authentication: idToken,
        };
        if (API_URL.USER.includes("ngrok-free.dev")) {
          headers["ngrok-skip-browser-warning"] = "true";
        }
        const response: Response = await fetch(
          `${API_URL.USER}?name=${loginId}`,
          {
            method: "GET",
            headers,
          }
        );
        if (!response.ok) {
          if (response.status === 401) {
            navigate("/signin");
          } else {
            clearSession();
            navigate("/error");
          }
          return;
        }
        const data = await response.json();
        const plan: string = data.results[0].Plan || "";
        sessionStorage.setItem("customerId", data.results[0].CustomerId || "");
        setPlan(plan || "");
        sessionStorage.setItem("plan", plan);
        sessionStorage.setItem(
          "paymentType",
          data.results[0].PaymentType || ""
        );
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        clearSession();
        navigate("/error");
      } finally {
        setIsLoading(false);
      }
    };
    fetchPlan();
  }, [navigate]);

  const clearSession: () => void = (): void => {
    sessionStorage.clear();
  };

  const cardItems = [
    {
      title: "プラグインDL",
      description: "プラグインをダウンロードします。",
      path: "/dl/plugin",
      icon: (
        <FileDownloadRoundedIcon sx={{ fontSize: "4rem", marginBottom: 1 }} />
      ),
    },
    {
      title: "マニュアルDL",
      description: "プラグインマニュアルをダウンロードします。",
      path: "/dl/manual",
      icon: (
        <SimCardDownloadRoundedIcon
          sx={{ fontSize: "4rem", marginBottom: 1 }}
        />
      ),
    },
    {
      title: "アップグレード",
      description: "プランをアップグレードします。",
      path: "/upgrade",
      icon: (
        <SwitchAccessShortcutAddRoundedIcon
          sx={{ fontSize: "4rem", marginBottom: 1 }}
        />
      ),
      disabled: plan !== "trial",
    },
    {
      title: "情報更新",
      description: "アカウント情報を更新します。",
      path: "/update",
      icon: (
        <ManageAccountsRoundedIcon sx={{ fontSize: "4rem", marginBottom: 1 }} />
      ),
    },
    {
      title: "PW変更",
      description: "パスワードを変更します。",
      path: "/pw/change",
      icon: <LockResetRoundedIcon sx={{ fontSize: "4rem", marginBottom: 1 }} />,
    },
  ];

  if (isLoading) {
    return (
      <>
        <HeaderSignOut />
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      </>
    );
  }

  return (
    <>
      <HeaderSignOut />
      <Container maxWidth="lg">
        <Box mt={10} textAlign="center">
          <Typography variant="h4" gutterBottom>
            Menu
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center" mt={18} gap={3}>
          {cardItems.map((item, index) => (
            <MenuCard key={index} item={item} />
          ))}
        </Box>
      </Container>
    </>
  );
};

export default MenuPage;
